export default __webpack_public_path__ + "static/video1-6ca400588c5c553b1bd09eb928477716.mp4";